import { combineReducers } from "redux";

import config from "./config_reducer";

const RootReducer = combineReducers({
  config,
});

export default RootReducer;
